import { FC, useEffect } from "react";
import "../CSS/CalendarDetailScreen.css";
import backIcon from "../../../assets/images/back-icon.svg";
import locationIcon from "../../../assets/images/location-icon.svg";
import starIcon from "../../../assets/images/communicate-star-icon.svg";
import { useNavigate } from "react-router-dom";
import ImageCarousel from "components/elements/ImageCarousel";
import { MEMBER_BENEFITS_TYPE } from "utils/constants";
import { getMemberBenefitsRealLifeImages } from "utils/utils";
import { IMAGE_LINK, WEB_LINK } from "utils/strings";
import { useLogout } from "services/LogoutProvider";
import { trackDetailView } from "utils/analytics";

const ScalingWorkshopDetailScreen: FC = () => {
  const navigate = useNavigate();
  const { handleAppExit } = useLogout();

  useEffect(() => {
    trackDetailView("creative_space", "CREATIVE_SPACE");
  }, []);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const openWorkspaceLocation = () => {
    handleAppExit(WEB_LINK.SABE_LOCATION);
  };

  return (
    <div className="wms-mobile-container">
      <div className="calendar_detail-screen-container">
        <div className="calendar_detail-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <span>
            Scaling <span style={{ color: "#ff6b35" }}>Workshops</span>
          </span>
        </div>
        <div
          className="calendar-detail-banner-image-container"
          style={{ backgroundImage: `url(${IMAGE_LINK.SCALING_WORKSHOPS})` }}
        ></div>
        <div className="calendar_detail-date-location-container">
          <div className="detail-container">
            <div className="image">
              <img src={locationIcon} alt="location-logo" />
            </div>
            <div className="right-container">
              <div className="sub-container">
                <span>SabeHub, Mohali</span>
                <span className="sub-text">SCO-4, 2nd Floor, Sec-68</span>
              </div>
              <button onClick={openWorkspaceLocation}>Direction</button>
            </div>
          </div>
        </div>
        <div className="calendar_detail-container">
          <span>
            About <span style={{ color: "#ff6b35" }}>Create Space</span>
          </span>
          <div className="divider"></div>
          <div className="communicate_space_container ">
            <span className="sub_text">
              Focused, hands-on sessions that give founders practical skills and
              immediate tools to scale smarter.
            </span>
            <span className="sub_text">
              Every Power Lab guarantees that founders leave with:
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> One ready-to-use tool,
              framework, or asset (Pitch script, checklist, ad structure,
              workflow, growth loop, decision framework, etc.)
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Live application during the
              session Founders build, write, or optimize it inside the Lab.
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Clear next steps So
              implementation continues the same day.
            </span>
            <span className="sub_text">
              Power Lab rule: If nothing is built, the Lab failed.
            </span>
          </div>
        </div>
        <div className="calendar_detail-contact-detail-container">
          <ImageCarousel
            images={getMemberBenefitsRealLifeImages(
              MEMBER_BENEFITS_TYPE.CREATIVE_SPACE,
            )}
            title="In Real"
            subTitle="Life"
          />
        </div>
        <button className="calendar_detail-reserve-btn">Comming Soon</button>
      </div>
    </div>
  );
};

export default ScalingWorkshopDetailScreen;
